var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.menuKey,
    ref: "sidebarContentWrapper",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "main-sidebar-content-wrapper"
    }
  }, [_c('ThemedLoading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false,
      "opacity": 0.9
    }
  }), _vm._l(_vm.menu, function (item, index) {
    return _c('SidebarMenuItem', {
      key: `${item.id}-${item.title}`,
      attrs: {
        "item": item,
        "collapse": _vm.shouldCollapseInitially(index) || _vm.openItemId !== null && _vm.openItemId !== item.id
      },
      on: {
        "item-opened": function ($event) {
          return _vm.$emit('item-click', $event);
        }
      }
    });
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }